module.exports = __webpack_public_path__ + "img/img8.9d1325c6.svg";